import _ from 'lodash'
import { createSelector } from 'reselect'

import * as mapSelectors from '../Mars/Map/map.selectors'

export const getTutorial = (state) => state.tutorial

export const isTutorialMode = createSelector([getTutorial], (tutorial) => tutorial.tutorialMode)

export const getUserMap = createSelector([getTutorial], (tutorial) => tutorial.userMap)

export const getPhasesInfo = createSelector([getTutorial], (tutorial) => ({
  error: null,
  phase: tutorial.phase,
}))

export const getTotalDisputes = createSelector([getTutorial], (tutorial) => tutorial.totalDisputes)

export const getCurrentPhase = createSelector([getTutorial], (tutorial) => tutorial.phase)

export const getVoteQuestion = createSelector([getTutorial], (tutorial) => tutorial.voteQuestion)

export const getGroupData = createSelector([getTutorial], (tutorial) => tutorial.groupData)

export const getCurrentUser = createSelector([getTutorial], (tutorial) => tutorial.currentUser)

export const getTutorialMessage = createSelector(
  [getTutorial],
  (tutorial) => tutorial.ui.tutorialMessage
)

export const getUI = createSelector([getTutorial], (tutorial) => tutorial.ui)

export const getMiningUI = createSelector([getTutorial], (tutorial) => tutorial.ui.mining)

export const getBuildingUI = createSelector([getTutorial], (tutorial) => tutorial.ui.building)

export const getMapUI = createSelector([getTutorial], (tutorial) => tutorial.ui.map)

export const getPhase1HideUI = createSelector([getTutorial], (tutorial) => tutorial.ui.phase1Hide)

export const getMiningScreen = createSelector([getTutorial], (tutorial) => tutorial.miningScreen)

export const getCurrentQuestion = createSelector(
  [getTutorial],
  (tutorial) => tutorial.currentQuestion
)

export const getIndicators = createSelector([getTutorial], (tutorial) => tutorial.indicators)
export const getIndicatorsObject = createSelector([getTutorial], (tutorial) =>
  Object.assign({}, tutorial.indicators)
)
export const getIndicatorsAsUserData = createSelector([getTutorial], (tutorial) => {
  let object = {}
  tutorial.indicators.map((indicator) => (object[indicator.id] = indicator.value))

  return object
})
export const getDebatesInfo = createSelector([getTutorial], (tutorial) => tutorial.debatesInfo)

export const getCountersData = createSelector(
  [getTutorial],
  (tutorial) => tutorial.userData.counters
)

export const getUserData = createSelector([getTutorial], (tutorial) => {
  return {
    ...tutorial.userData,
    phase: tutorial.phase,
    turn: tutorial.turn,
  }
})

export const getMiningFeedBack = createSelector(
  [getTutorial],
  (tutorial) => tutorial.miningFeedBack
)

export const getPrizeCoins = createSelector([getTutorial], (tutorial) => tutorial.prizeCoins)

export const getBuildings = createSelector(
  [mapSelectors.getBuildings, getBuildingUI],
  (buildings, buildingUI) => {
    const { buildingsAvailable } = buildingUI
    return _.pickBy(buildings, (building) => {
      return _.includes(buildingsAvailable, building.id)
    })
  }
)

export const getBuildingTypes = createSelector(
  [mapSelectors.getBuildingTypes, getBuildings],
  (buildingTypes, buildings) => {
    const availableTypes = {}
    Object.keys(buildings).map((buildingName) => {
      const buildingType = buildings[buildingName].type
      availableTypes[buildingType] = buildingTypes[buildingType]
    })
    return availableTypes
  }
)

export const getProfileBattles = createSelector(
  [getTutorial],
  (tutorial) => tutorial.profileBattles
)

export const getDisplayingBuildingCard = createSelector(
  [getTutorial],
  (tutorial) => tutorial.buildingScreen.displayingBuildingCard
)

export const getAcademySwitch = createSelector([getTutorial], (tutorial) => tutorial.academySwitch)

export const getPlayerList = createSelector([getTutorial], (tutorial) => tutorial.playerList)

export const getPlayerRanking = createSelector(
  [getPlayerList, getCurrentUser],
  (playerList, currentUser) => {
    let ranking = Object.keys(playerList).map((item) =>
      Object.assign({}, { licenseId: item }, playerList[item])
    )
    ranking.push(currentUser)
    ranking.sort((item1, item2) => (item1.settlers < item2.settlers ? 1 : -1))
    ranking = ranking.map((item, index) => Object.assign({}, item, { position: index + 1 }))
    return ranking
  }
)

export const getOwnPlayerID = createSelector([getTutorial], (tutorial) => tutorial.ownPlayerID)

export const getUserDataShield = createSelector(
  [getCurrentUser],
  (tutorial) => tutorial.colonyShield
)

export const getTurn = createSelector([getTutorial], (tutorial) => tutorial.turn)

export const getConfidentialNumber = createSelector(
  [getTutorial],
  (tutorial) => tutorial.confidentialNumber
)

export const getRivalInfo = createSelector([getTutorial], (tutorial) => tutorial.rivalInfo)

export const getCurrentBattle = createSelector([getTutorial], (tutorial) => tutorial.currentBattle)

export const getIndividualBattle = createSelector(
  [getTutorial],
  (tutorial) => tutorial.individualBattle
)
export const getBattleQuestions = createSelector(
  [getTutorial],
  (tutorial) => tutorial.battleQuestions
)
export const getBattleInfoFromState = createSelector(
  [getTutorial],
  (tutorial) => tutorial.currentBattle.info
)
export const getBattlequestionNum = createSelector(
  [getTutorial],
  (tutorial) => tutorial.currentBattle.info.question - 1
)

export const getCurrentBattleQuestion = createSelector(
  [getTutorial, getBattlequestionNum],
  (tutorial, questionNum) => {
    const testQuestions = tutorial.currentBattle.questions
    const questions = tutorial.battleQuestions
    return questions[testQuestions[questionNum]]
  }
)
export const getCurrentBattleResults = createSelector(
  [getTutorial, getBattleQuestions],
  (tutorial, battleQuestions) => {
    let results = tutorial.currentBattle.results[tutorial.ownPlayerID]
    delete results.endTime
    delete results.startTime
    delete results.finished
    Object.keys(results).map((question) => {
      results[question].question = battleQuestions[question].question
      results[question].choices = battleQuestions[question].choices
    })
    return results
  }
)

export const getVisitorMap = createSelector([getTutorial], (tutorial) => tutorial.visitorMap)

export const getAllVisitorsMap = createSelector([getTutorial], (tutorial) => tutorial.allVisitors)
export const getCurrentStore = createSelector([getTutorial], (tutorial) => {
  const store = tutorial.currentStore
  return { storeName: store }
})

export const getVisitorInfo = createSelector([getVisitorMap, getPlayerList], (map, playersList) => {
  if (!playersList || !playersList[map.visitorId]) {
    return null
  }
  return {
    ...playersList[map.visitorId],
    id: map.visitorId,
  }
})

export const getOldMessageId = createSelector([getTutorial], (tutorial) => tutorial.oldMessageId)

// TODO put visitor map like getBuildingSelected in mapSelectors.getBuildingSelected
export const getBuildingSelected = createSelector(
  [mapSelectors.getSelectedTile, getUserMap, getVisitorMap],
  (selectedTile, userMap, visitorMap) => {
    let buildings = visitorMap.mapId ? visitorMap.buildings : userMap.buildings
    let found = selectedTile ? buildings[selectedTile.q + '_' + selectedTile.r] : null
    return found
  }
)
export const getUserInfo = createSelector([getTutorial], (tutorial) => tutorial.userInfo)

export const getVisitorIndicators = createSelector(
  [getVisitorMap, getPlayerList],
  (map, playersList) => {
    if (!playersList) {
      return null
    }
    return playersList[map.visitorId]
  }
)

export const isUrlMode = createSelector([getTutorial], (tutorial) => tutorial.urlMode)

export const getMISInfo = createSelector([getTutorial], (tutorial) =>
  tutorial.activity.map((activity) => Object.assign({}, activity.data, { type: activity.type }))
)

export const getCurrentPosition = createSelector(
  [getCurrentUser, getPlayerRanking],
  (currentUser, playerRanking) => {
    const currentUserInRanking = playerRanking.find(
      (item) => item.licenseId === currentUser.licenseId
    )
    return currentUserInRanking.position
  }
)
